<template>
  <div>
    <div v-html="$t('disabilities_description')"></div>

    <div class="row">
      <div class="col-md-12" v-for="(disability,idx) in disabilities" :key="idx">
        <fieldset class="well">
          <legend>
            <span>Rodzaj niepełnosprawności</span>
            <button
              class="btn btn-danger pull-right"
              @click.prevent="removeDisability(idx)"
              v-if="idx > 0 || disabilities.length > 1"
            >
              <i class="glyphicon glyphicon-remove">x</i>
              <span class="sr-only">Usuń niepełnosprawność</span>
            </button>
          </legend>

          <div class="row">
            <div class="col-sm-5">
              <ic-form-row
                aria="Pole jest wymagane"
                label="Rodzaj niepełnosprawności"
                :new_id="'type' + idx"
                :error="hasError('form.disabilities[' + idx + '].type')"
                :required="isRequired('form.disabilities[' + idx + '].type')"
              >
                <ic-select-system
                  :id="'type' + idx"
                  v-model="disability.type"
                  :values="disabilityTypes"
                  @update:select="onUpdateDisability(idx)"
                  :v="v.form.disabilities.$each[idx].type"
                  :placeholder="'... (Wybierz jedną z '+disabilityTypes.length+' opcji)'"
                ></ic-select-system> 
              </ic-form-row>
            </div>
            <div class="col-sm-2 col-xs-4" v-if="disability.type || disability.persons">
              <ic-form-row
                aria="Pole jest wymagane"
                label="Liczba osób"
                :new_id="'persons' + idx"
                :error="hasError('form.disabilities[' + idx + '].persons')"
                :required="isRequired('form.disabilities[' + idx + '].persons')"
              >
                <ic-input
                  :id="'persons' + idx"
                  type="number"
                  v-model="disability.persons"
                  :v="v.form.disabilities.$each[idx].persons"
                ></ic-input>
              </ic-form-row>
            </div>
            <div
              class="col-sm-5 col-xs-8 form-padding-left"
              v-if="disability.type || disability.persons"
            >
              <ic-form-row
                aria="Pole jest wymagane"
                label="Rodzaj zaopatrzenia ortopedycznego"
                :new_id="'equipment' + idx"
                :error="hasError('form.disabilities[' + idx + '].equipment')"
                :required="isRequired('form.disabilities[' + idx + '].equipment')"
              >
                <ic-checkbox-group 
                  :id="'equipment' + idx"
                  v-model="disability.equipment"
                  :options="equipmentTypes[idx]"
                  :v="v.form.disabilities.$each[idx].equipment"
                  @update:select="onUpdateEquipment(idx)"
                ></ic-checkbox-group> 
                <!-- <ic-select
                  :id="'equipment' + idx"
                  v-model="disability.equipment"
                  :values="equipmentTypes[idx]"
                  :v="v.form.disabilities.$each[idx].equipment"
                  :multiple="true"
                  :placeholder="'... (Wybierz jedną lub kilka z '+equipmentTypes[idx].length+' opcji)'"
                  update:select="onUpdateEquipment(idx)"
                ></ic-select> -->
              </ic-form-row>
            </div>
          </div>

          <ic-form-row
            new_id="size"
            v-if="hasWheelchair(idx)"
            :error="hasError('form.disabilities[' + idx + '].size')"
          >
            <p v-if="!disability.size">{{$t('disabilities_size_description')}}</p>

            <ic-checkbox
              :id="'size' + idx"
              aria="Pole jest wymagane"
              v-model="disability.size"
              :val="1"
              :v="v.form.disabilities.$each[idx].size"
            >Oświadczam, że wózek inwalidzki nie przekracza granicznych wymiarów i wagi *</ic-checkbox>
          </ic-form-row>

          <ic-form-row id="sizePicture" v-if="hasWheelchair(idx)">
            <img
              src="img/wymiary_wozka.png"
              class="img-responsive"
              style="max-width: 500px; display: block; margin: 20px auto"
              alt="Rysunek z podanymi wymiarami granicznymi wózka inwalidzkiego, dopuszczonego do przewozu koleją"
            />
            <p>Graniczne parametry konstrukcyjne wózka inwalidzkiego przystosowanego do przewozu koleją są następujące:</p>
            <ul>
              <li>szerokość 700 mm powiększona o co najmniej 50 mm z każdej strony na ręce podczas przemieszczania się;</li>
              <li>długość 1 200 mm powiększona o 50 mm na stopy;</li>
              <li>koła — najmniejsze koło musi być w stanie pokonać szczelinę o szerokości 75 mm w poziomie i różnicę wysokości 50 mm;</li>
              <li>wysokość — maksimum 1 375 mm wraz z użytkownikiem płci męskiej;</li>
              <li>łuk skrętu — 1 500 mm;</li>
              <li>masa przy pełnym obciążeniu wózka z użytkownikiem (oraz z ewentualnym bagażem) wynosząca 300 kg w przypadku elektrycznego wózka inwalidzkiego, dla którego nie jest wymagana pomoc w celu przejechania przez urządzenie wspomagające wsiadanie;</li>
              <li>w przypadku gdy jest wymagana pomoc w celu przejechania przez urządzenie wspomagające wsiadanie masa taka wynosi 300 kg (do takiej masy są przystosowane rampy);</li>
              <li>masa przy pełnym obciążeniu wózka z użytkownikiem (oraz z ewentualnym bagażem) wynosząca 200 kg w przypadku ręcznego wózka inwalidzkiego.</li>
            </ul>
          </ic-form-row>

          <ic-form-row
            label="Uwagi"
            :new_id="'remarks' + idx"
            v-if="disability.type == 'other' || disability.equipment.indexOf('other') > -1"
            :error="hasError('form.disabilities[' + idx + '].remarks')"
            :required="isRequired('form.disabilities[' + idx + '].remarks')"
          >
            <ic-textarea
              :id="'remarks' + idx"
              v-model="disability.remarks"
              :v="v.form.disabilities.$each[idx].remarks"
            ></ic-textarea>
          </ic-form-row>
        </fieldset>
      </div>
    </div>

    <button
      class="btn btn-toggle btn-block btn-secondary mt-3"
      @click.prevent="addDisability"
      v-if="this.disabilities.length < 6"
    >Dodaj rodzaj niepełnosprawności</button>
  </div>
</template>

<script>
/*
        <ic-form-row-horizontal2 id="persons" label="Liczba opiekunów/os. towarzyszących" :labelWidth="5" :controlWidth="2" :error="hasError('form.persons')" v-if="hasParticipants">
        <ic-input v-model="persons" :v="v.form.persons" @input="$emit('update:persons', $event)"></ic-input>
      </ic-form-row-horizontal2>
   */
import IcFormRow from "@/components/ic-common/form/helpers/FormRow.vue";
import IcFormRowHorizontal2 from "@/components/ic-common/form/helpers/FormRowHorizontal2.vue";
import IcSelect from "@/components/ic-common/form/controls/Select.vue";
import IcSelectSystem from "@/components/ic-common/form/controls/SelectControl.vue";
import IcInput from "@/components/ic-common/form/controls/Input.vue";
import IcTextarea from "@/components/ic-common/form/controls/Textarea.vue";
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox.vue";
import IcCheckboxGroup from "@/components/ic-common/form/controls/CheckboxGroup.vue";
import { disabilityTypes, equipmentTypes, sizeTypes } from "./storage";

export default {
  name: "IcFormOznDisability",
  props: {
    value: {
      type: Array
    },
    v: {
      type: Object
    },
    participants: {
      type: Array
    },
    hasError: {
      type: Function,
      required: true
    },
    isRequired: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      persons: "",
      disabilities: this.value,
      disabilityNames: [],
      disabilityTypes: disabilityTypes,
      equipmentTypesAll: equipmentTypes,
      sizeTypes: sizeTypes
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.disabilities = this.value;
      }
    }
  },
  computed: {
    equipmentTypes() {
      let list = [];
      this.disabilities.forEach(item => {
        let type = item.type;
        list.push(
          this.equipmentTypesAll.filter(item => {
            return (item.for && item.for.indexOf(type) !== -1) || !item.for;
          })
        );
      });
      return list;
    },
    hasParticipants() {
      return (
        this.participants.length > 0 &&
        (this.participants.indexOf("carer") != -1 ||
          this.participants.indexOf("guide") != -1 ||
          this.participants.indexOf("other") != -1)
      );
    },
    disabled_persons: {
      get() {
        let count = 0;
        this.disabilities.forEach(item => {
          let persons = parseInt(item.persons);
          return !isNaN(persons) ? (count += persons) : false;
        });
        this.$emit("update:disabled_persons", count);
        return count;
      },
      set() {}
    }
  },
  mounted() {
    if (this.disabilities.length === 0) {
      this.addItem();
    }
  },

  methods: {
    hasWheelchair(idx) {
      return (
        this.disabilities[idx].equipment.join(",").indexOf("wheelchair") !== -1
      );
    },
    addDisability() {
      if (this.disabilities.length < 6) {
        this.addItem();
      }
    },
    removeDisability(idx) {
      this.disabilities.splice(idx, 1);
    },
    onUpdateDisability(idx) {
      let disability = this.disabilities[idx];
      console.log(idx,disability,this.disabilities);
      setTimeout(() => {
        switch (disability.type) {
          case "wheelchair":
            this.disabilities[idx].equipment = ["maunal_wheelchair"];
            break;
          case "walk_diffuculty":
            this.disabilities[idx].equipment = ["crutches"];
            break;
          case "blind":
            this.disabilities[idx].equipment = ["white_cane"];
            break;
          case "eldery":
            this.disabilities[idx].equipment = [];
            break;
          default:
            this.disabilities[idx].equipment = ["other"];
        }
      }, 200);
    },
     onUpdateEquipment(idx) {
    //   if (this.disabilities[idx].equipment.indexOf('na') > -1) {
    //     this.disabilities[idx].equipment = ['na']
    //   }
     },
    addItem() {
      this.disabilities.push({
        persons: "",
        type: "",
        equipment: [],
        size: "",
        remarks: ""
      });
    }
  },
  components: {
    IcFormRow,
    IcFormRowHorizontal2,
    IcSelect,
    IcInput,
    IcTextarea,
    IcCheckbox,
    IcCheckboxGroup,
    IcSelectSystem
  }
};
</script>

<style>
</style>
